/** @jsx jsx */
import { jsx } from 'theme-ui';
/* import React from "react"; */
import { graphql} from "gatsby";
import Layout from "../components/layout";
import SEO from './../components/seo';

import Instagram from './../components/instagram';

const Connect = ({data}) => {
  return (
    <Layout>
      <SEO title="Mabel Gago | Connect"/>
      <section sx={connectStyles.contactSection}>
        <h1>Contact Mabel</h1>
        <p>In addition to event and editorial styling, Mabel is available for brand and image consulting, brand collaborations, music videos, as well as hosting and appearances. Or, direct your own fashion and wardrobe concerns and questions – she’s happy to help with virtual styling!</p>

        <a href="mailto:jmabel@gmail.com"
            className="button"
            sx={{
              variant: 'links.button'
            }}
          >CONTACT ME
          </a>
      </section>

      <section>
        <h2>Instagram latest Feed</h2>
        <Instagram posts={data.allInstagramContent} />
      </section>
    </Layout>
  )
}

export default Connect;
export const query = graphql`
  query InstagramPosts {
    allInstagramContent(limit:12) {
      edges {
        node {
          caption
          localImage {
            childImageSharp {
              fluid(maxHeight: 500, maxWidth: 500, quality: 50) {
                ...GatsbyImageSharpFluid_withWebp_tracedSVG
              }
            }
          }
        }
      }
    }
  }
`

const connectStyles = {
  contactSection: {
    margin:"15% auto",
  }
} 

